import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Rx';

//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';
import { newnscModel } from '../../models/newNSC/new.nsc.model';
import { consumerBasicInfoModel } from '../../models/consumerBasicInfo/consumerBasicInfo.model';
import { AppSettings } from '../../config/settings/app-settings';
import * as CryptoJS from 'crypto-js';
import * as $ from 'jquery';
@Component({
  selector: 'app-newnsc',
  templateUrl: './newNsscReg.component.html'
})
export class NewNscRegComponent implements OnInit {

  //variable deceleration
  public errorMsg: string = "";
  public successMsg: string = "";
  public sessionData: any;
  public consumerBasicInfoModel: consumerBasicInfoModel = new consumerBasicInfoModel;
  public serviceOn: boolean = false;
  public showEmailOtp: boolean = true;
  public showEmailOtpBtn: boolean = true;
  public showNewNsscRegForm: boolean;
  public CreateUserResponseData: any = "";
  public hideTransaction: boolean = true;
  public emailID: string = "";
  public transId: string;
  public transcId: string;
  public emailOTP: boolean;
  public returnVal: boolean;
  public emailOTPData: any;
  public activeResendOtp: boolean = false;
  public hidePassword: boolean = true;
  public isValidateEmail: boolean = false;
  public newNscRegPostData = {
    "transactionId": null,
    "emailId": null,
    "newPassword": null,
    "confirmPassword": null,

  }

  public emailOtpPostData = {
    "emailOTP": null,
    "transactionId": null
  }

  public transactionLoginPostData = {
    "transactionId": null,
    "newPassword": null

  }
  public showPatternPwd:boolean = false ;
  public patternPwd : string ="";
  public disableSubmit :boolean = false ;

  constructor(public http: HttpTestService, public session: sessionServices, public router: Router, private route: ActivatedRoute) {
    var self = this;
    // self.showEmailOtp = false;
    //self.showEmailOtpBtn = false;
    self.showNewNsscRegForm = true;

    // self.hideTransaction = false;
    self.transcId = self.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.getSession();
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
    this.startTimer();
  }

  //get session details
  getSession = function () {
    this.sessionData = this.session.getSessionDetails();
  }

  startTimer = function () {
    var numbers = Observable.timer(45000);
    numbers.subscribe(x => {
      this.activeResendOtp = true;
    });
  }

  getConsumerDetails = function (requestedConsumer) {
    var self = this;
    self.errorMsg = "";
    self.successMsg = "";

    self.http.getUserDetailsByConsNo(requestedConsumer)
      .subscribe(
        (data) => {
          self.loggedInUserData = data;
          self.loggedInUserData.name = "AAAA";
          self.loggedInUserData.emailid = "aa@gmail.com";
          self.loggedInUserData.region = "Kolkata";
          self.loggedInUserData.businessArea = "New Town";
        },
        (error) => {
          self.errorMsg = error;
          self.loggedInUserData = "";
        },
        () => {
          if (self.loggedInUserData.name) {
            //alert("Loggedin name: "+self.loggedInUserData.consumerNo);
            var key = AppSettings.SEC_KEY_ID_1;
            var iv = AppSettings.SEC_KEY_ID_2;
            var sessionKey = AppSettings.SEC_KEY_ID_1 + "true!^@#" + AppSettings.SEC_KEY_ID_1 + self.loggedInUserData.name + "!^@#" + AppSettings.SEC_KEY_ID_1 + self.loggedInUserData.emailid + "!^@#" + AppSettings.SEC_KEY_ID_1 + self.loggedInUserData.region + "!^@#" + AppSettings.SEC_KEY_ID_1 + self.loggedInUserData.businessArea + "!^@#" + AppSettings.SEC_KEY_ID_1 + self.loggedInUserData.consumerNo + "!^@#" + AppSettings.SEC_KEY_ID_1 + self.loginmodel.SignInPass;
            var encrypted: any = CryptoJS.AES.encrypt(sessionKey, key, { iv: iv });
            encrypted = (encrypted).toString();
            window.sessionStorage.setItem('sessionKey', encrypted);
            window.location.replace('');
          }

        }
      );
  }

  validateEmail = function () {
    var self = this;
    self.errorMsg = "";
    self.successMsg = "";
    this.showEmailOtp = false;
    this.showEmailOtpBtn = false;
    this.showNewNsscRegForm = false;
    this.hidePassword = true;
    this.hideTransaction = true;
    this.isValidateEmail = true;
    self.newNscRegPostData.transactionId = self.transcId;
    self.newNscRegPostData.emailId = self.consumerBasicInfoModel.emailId;
    self.newNscRegPostData.newPassword = self.consumerBasicInfoModel.newPassword;
    self.newNscRegPostData.confirmPassword = self.consumerBasicInfoModel.confirmPassword;
    self.transId = self.newNscRegPostData.transactionId;
    this.emailID = self.newNscRegPostData.emailId;
   
    //if (self.newNscRegPostData.newPassword == self.newNscRegPostData.confirmPassword) {
    //  self.successMsg = "";

      self.http.postNScReg(self.newNscRegPostData)
        .subscribe(
          (data) => {
            self.CreateUserResponseData = data;

          },
          (error) => {
            self.errorMsg = error;
          },
          () => {

            //	self.successMsg = "You have successfully submitted the NSC request.We will contact you soon.";
            self.serviceOn = false;

            //self.consumerBasicInfoModel.transactionId="";
            self.consumerBasicInfoModel.emailId = "";
            self.consumerBasicInfoModel.newPassword = "";
            self.consumerBasicInfoModel.confirmPassword = "";
            self.serviceOn = true;
            self.otpSend = false;

          }
        );

    // } else {

    //   self.errorMsg = "Password not match";
    //   this.showEmailOtp = false;
    //   this.showEmailOtpBtn = false;
    //   this.showNewNsscRegForm = true;
    // }


  }

  sendTranscReqPassword = function () {

    var self = this;
    self.errorMsg = "";
    self.successMsg = "";
    this.showEmailOtp = true;
    this.hideTransaction = false;
    this.showEmailOtpBtn = true;
    this.showNewNsscRegForm = false;
    this.hidePassword = true;

    self.newNscRegPostData.transactionId = self.transcId;
    self.newNscRegPostData.emailId = self.consumerBasicInfoModel.emailId;
    self.newNscRegPostData.newPassword = self.consumerBasicInfoModel.newPassword;
    self.newNscRegPostData.confirmPassword = self.consumerBasicInfoModel.confirmPassword;
    self.transId = self.newNscRegPostData.transactionId;

    if (self.newNscRegPostData.newPassword == self.newNscRegPostData.confirmPassword) {
      self.successMsg = "";

      self.http.postNScPassReg(self.newNscRegPostData)
        .subscribe(
          (data) => {
            self.CreateUserResponseData = data;

          },
          (error) => {
            // alert("wrong pass word")
            self.errorMsg = error;
          },
          () => {

            //	self.successMsg = "You have successfully submitted the NSC request.We will contact you soon.";
            self.serviceOn = false;

            //self.consumerBasicInfoModel.transactionId="";
            self.consumerBasicInfoModel.emailId = "";
            self.consumerBasicInfoModel.newPassword = "";
            self.consumerBasicInfoModel.confirmPassword = "";
            self.serviceOn = true;
            self.otpSend = false;


          }
        );

    } else {

      self.errorMsg = "Password not match";
      this.hideTransaction = true;
      this.hidePassword = false;
      // this.showEmailOtp = false;
      //  this.showEmailOtpBtn = false;
      //  this.showNewNsscRegForm = true;
    }


  }

  sendEmailOtpReq = function () {
    var self = this;
    self.errorMsg = "";
    self.hideTransaction = true;
    self.hidePassword = false;
    self.showEmailOtpBtn = true;
    self.showEmailOtp = true;
    self.emailOtpPostData.emailOTP = self.consumerBasicInfoModel.emailOTP;
    self.emailOtpPostData.transactionId = self.transId;

    self.http.postEmailOtpData(self.emailOtpPostData).subscribe(
      (data) => {
        self.CreateUserResponseData = data;
        self.emailOTP = self.CreateUserResponseData;
        if (!self.emailOTP) {
          self.showEmailOtp = false;
          self.showEmailOtpBtn = false;
          self.hideTransaction = true;
          self.hidePassword = true;
          self.errorMsg = "Email Otp is not valid";
        } else if (self.emailOTP) {
          self.errorMsg = "";
          self.showEmailOtp = true;
          self.showEmailOtpBtn = true;
          self.hideTransaction = true;
          self.hidePassword = false;
        }
        //  if(self.emailOTP){
        //       self.showEmailOtp = false;
        //       self.showEmailOtpBtn = false;
        //       self.hideTransaction = true;
        //       self.hidePassword = true;
        //       self.errorMsg = "Email Otp is not valid";
        //     }
        // else if(!self.emailOTP){
        //           self.showEmailOtp = true;
        //           self.showEmailOtpBtn = true;
        //           self.hideTransaction = true;
        //           self.hidePassword = false;
        //     }
      },
      (error) => {
        self.errorMsg = error;
      },
    () => { });
  }

  resendEmailOtpReq = function () {
    var self = this;
    self.http.getResendEmailOTP(self.transId).subscribe(
      (data) => {
          self.emailOTPData = data;
          self.emailOTP = self.emailOTPData;
          if (!self.emailOTP) {
            // self.showEmailOtp = true;
            // self.showEmailOtpBtn = true;
            // self.hideTransaction = false;
            self.errorMsg = "Error in resending Email Otp";
          }
          else if (self.emailOTP) {
            self.errorMsg = "";
            //  self.showEmailOtp = false;
            //  self.showEmailOtpBtn = false;
            //  self.hideTransaction = true;
            self.activeResendOtp = false;
            self.startTimer();
          }
          //  if(self.emailOTP){
          //       self.showEmailOtp = true;
          //       self.showEmailOtpBtn = true;
          //       self.hideTransaction = false;
          //       self.errorMsg = "Email Otp is not valid";
          //     }
          // else if(!self.emailOTP){
          //       self.errorMsg = "";
          //       self.showEmailOtp = false;
          //       self.showEmailOtpBtn = false;
          //       self.hideTransaction = true;
          //     }
        },
        (error) => {
          self.errorMsg = error;
        },
    () => { });
  }

  transactionLogin = function () {
    // alert("Transaction");
    var self = this;
    self.errorMsg = "";
    self.transactionLoginPostData.transactionId = self.transcId;
    self.http.postTransactionLoginData(self.transactionLoginPostData)
      .subscribe(
        (data) => {
          self.CreateUserResponseData = data;
          self.returnVal = self.CreateUserResponseData;
          if (self.returnVal) {
            self.http.authenticateUser(this.emailID + "^" + self.transactionLoginPostData.newPassword)
              .subscribe(
                (data) => {
                  self.authUser = data;
                },
                (error) => {
                  self.errorMsg = error;
                  self.authUser = false;
                },
                () => {

                  if (self.authUser) {
                    //self.sendOTP();
                    self.getConsumerDetails(self.consumerBasicInfoModel.emailId);
                  } else {
                    self.errorMsg = "Please use a valid credential.";
                  }
                }
              );
            document.getElementById("trans").style.display = "none";
            self.router.navigate(['/consumerBasicInfo', this.transcId], { skipLocationChange: false });

          } else if (!self.returnVal) {
            self.errorMsg = "Password Does Not Match!!";
            document.getElementById("trans").style.display = "block";
          }

        },
        (error) => {
          self.errorMsg = error;
        },
        () => { }
      );


  }
  //-------------------validateNewPassword--------------------//
  validateNewPassword(){
    //this.showPatternPwd = true ;
    this.patternPwd = "Password should be at least 8 characters but less than 20 characters with at least one number, one special character(i.e. ?=.*[!@#$%^&] ) and one character!";
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    if(strongRegex.test(this.consumerBasicInfoModel.newPassword)) {
      this.showPatternPwd = false ;
    } else { this.showPatternPwd = true ;}
  }
  checkPassword(){
    if(!this.consumerBasicInfoModel.newPassword || this.consumerBasicInfoModel.newPassword.trim().toLowerCase() == '' || this.consumerBasicInfoModel.newPassword == null || this.consumerBasicInfoModel.confirmPassword == undefined || !this.consumerBasicInfoModel.confirmPassword || this.consumerBasicInfoModel.confirmPassword == null || this.consumerBasicInfoModel.confirmPassword == undefined || this.consumerBasicInfoModel.confirmPassword.trim().toLowerCase() == ''){
      this.disableSubmit = true
      this.errorMsg = 'Invalid input'
    }
    else if(this.consumerBasicInfoModel.newPassword != this.consumerBasicInfoModel.confirmPassword){
      this.errorMsg = 'Password and confirm password does not match!'
      this.disableSubmit = true
    }
    else if(this.consumerBasicInfoModel.newPassword == this.consumerBasicInfoModel.confirmPassword){
      this.disableSubmit = false
      this.errorMsg = null
    }
  }
  //-----------------End of validateNewPassword---------------------//
  authenticateUser = function () {
    //	alert("OKK");
    var self = this;
    self.http.authenticateUser(self.loginmodel.SignInEmail + "^" + self.loginmodel.SignInPass)
      .subscribe(
        (data) => {
          self.authUser = data;
        },
        (error) => {
          self.errorMsg = error;
          self.authUser = false;
        },
        () => {

          if (self.authUser) {
            //self.sendOTP();
            self.getConsumerDetails(self.loginmodel.SignInEmail);
          } else {
            self.errorMsg = "Please use a valid credential.";
          }
        }
      );
  }
}


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/newNscReg/newNscReg.component.ts